import { useState } from "react";
import { FaEnvelope } from "react-icons/fa";
import { sendSignInLinkToEmail } from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig"; // Ensure this points to your Firebase config file

const RegisterForm = ({ toggleForm, setShowPopup }) => {
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showTermsError, setShowTermsError] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isChecked) {
      setShowTermsError(true);
      return;
    }

    setLoading(true);
    try {
        const usersRef = collection(db, "users");
        const q = query(usersRef, where("email", "==", formData.email));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          toast.error("This email is already registered. Please log in.");
          setLoading(false);
          return;
        }


      const actionCodeSettings = {
        url: `${window.location.origin}/email-verification`, // ✅ Redirect URL after email verification
        handleCodeInApp: true,
      };
      
      await sendSignInLinkToEmail(auth, formData.email, actionCodeSettings);
      localStorage.setItem("emailForRegistration", formData.email); // ✅ Store email for later password setup

      toast.success("Verification email sent! Please check your inbox.");
    } catch (error) {
      toast.error(error.message);
    }
    setLoading(false);
  };

  return (
    <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-md max-w-md mx-auto">
      <h2 className="text-3xl font-bold mb-4 text-center text-gray-900 dark:text-white">
        Register
      </h2>

      {showTermsError && (
        <div className="mb-2 text-center text-red-600 rounded-lg">
          You must agree to the Terms & Conditions to proceed.
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">
            Email
          </label>
          <div className="relative">
            <FaEnvelope className="absolute left-3 top-3 text-gray-500 dark:text-gray-300" />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-10 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-black 
              dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:focus:ring-white transition-all duration-300"
              placeholder="Enter your email"
              required
            />
          </div>
        </div>

        <div className="mb-4 flex items-center">
          <input
            type="checkbox"
            id="terms"
            className="mr-2"
            checked={isChecked}
            onChange={() => {
              setIsChecked(!isChecked);
              setShowTermsError(false);
            }}
          />
          <label htmlFor="terms" className="text-sm text-gray-700 dark:text-gray-300">
            I agree to the{" "}
            <span
              className="text-blue-600 dark:text-blue-400 underline cursor-pointer"
              onClick={() => setShowPopup(true)}
            >
              Terms & Conditions
            </span>
          </label>
        </div>

        <button
          type="submit"
          className="w-full py-2 rounded-lg font-semibold bg-blue-500 text-white hover:bg-blue-600 transition-all duration-300"
        >
          {loading ? "Sending Email..." : "Send Verification Email"}
        </button>
      </form>

      <p className="text-center text-sm mt-4 text-gray-700 dark:text-gray-300">
        Already have an account?{" "}
        <button
          onClick={toggleForm}
          className="font-semibold underline text-blue-700 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-500"
        >
          Login
        </button>
      </p>
    </div>
  );
};

export default RegisterForm;
